import { useTranslation } from 'react-i18next'

/** Shown by the top-level error boundary instead of a blank page. */
export default function ErrorFallback() {
  const { t } = useTranslation()
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center gap-4 bg-white p-4 text-center">
      <p className="text-lg font-medium text-gray-900">{t('errors.crashed')}</p>
      <button
        onClick={() => window.location.reload()}
        className="rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
      >
        {t('errors.reload')}
      </button>
    </div>
  )
}
